import React from 'react';
import Layout from '../../components/global/layout';
import './style.scss';
import { Link } from 'react-router-dom';
import { Tooltip } from "antd";
import { FiEdit3, FiPlus } from 'react-icons/fi';
import { FaTrashAlt } from 'react-icons/fa';
import Table from "../../components/Table";
import SelectDropdown from '../../components/common/SelectDropdown';
import statusModel from '../../models/status.model';
import datepipeModel from '../../models/datepipemodel';
import shared from "./shared";
import ApiClient from '../../methods/api/apiClient';
import { useSelector } from 'react-redux';
import environment from '../../environment';

const Html = ({
    sorting,
    edit,
    view,
    statusChange,
    roleUpdate,
    pageChange,
    count,
    deleteItem,
    clear,
    filters,
    loaging,
    data,
    changestatus,
    isAllow,
    filter,
    setFilter,
    total,
    roles = [],
    invitations = [],
    revokeInvitation,
    resendInvitation,
    resendAllInvitations,
    handleAddMember,
    deleteInvitation
}) => {
    const user = useSelector((state) => state.user);
    const isGroupLeader = environment.groupLeaderRoleIds.includes(user?.customerRole?._id || user?.customerRole);

    const groupId = user?.lastUsedGroupId?._id || user?.lastUsedGroupId || user?.groupId?._id || user?.groupId;
    const profileLink = (row) => `/user-profile/${row.odlUserId || row.id || row._id}${groupId ? `?groupId=${groupId}` : ''}`;

    const getFirstName = (row) => {
        if (row?.firstName) return row.firstName;
        if (row?.fullName) {
            const parts = row.fullName.trim().split(' ');
            return parts[0];
        }
        return '';
    };
    const getLastName = (row) => {
        if (row?.lastName) return row.lastName;
        if (row?.fullName) {
            const parts = row.fullName.trim().split(' ');
            return parts.slice(1).join(' ');
        }
        return '';
    };

    const columns = [
        {
            key: 'firstName', name: 'First Name',
            render: (row) => {
                return <Link to={profileLink(row)} className='text-orange-600 hover:underline'>{getFirstName(row)}</Link>
            }
        },
        {
            key: 'lastName', name: 'Last Name' ,
            render: (row) => {
                return <Link to={profileLink(row)} className='text-orange-600 hover:underline'>{getLastName(row)}</Link>
            }
        },
        {
            key: 'email', name: 'Email',
            render: (row) => {
                return <>{row?.email}</>
            }
        },
        ...(isGroupLeader ? [{
            key: 'role', name: 'Role',
            render: (row) => {
                return <>
                    <SelectDropdown
                    placeholder="Select Role"
                    intialValue={row.customerRole}
                    displayValue="name"
                    valueKey="id"
                    options={roles}
                    result={e=>{
                        roleUpdate(row, e.id || e.value)
                    }}
                    />
                </>
            }
        }] : []),
        ...(isGroupLeader ? [{
            key: 'action', name: 'Action',
            render: (itm) => {
                return <>
                    <div className="flex items-center justify-start gap-1.5">
                    {/* <Tooltip placement="top" title="View">
                                <a className="border cursor-pointer border-[#ff7641] hover:opacity-70 rounded-lg bg-[#ff764114] w-10 h-10 !text-primary flex items-center justify-center text-xl" onClick={e => view(itm.id)}>
                                <span class="material-symbols-outlined">visibility</span>
                                </a>
                            </Tooltip> */}
                        {/* {isAllow(`edit${shared.check}`) ?
                            <Tooltip placement="top" title="Edit">
                                <a className="border cursor-pointer border-[#ff7641] hover:opacity-70 rounded-lg bg-[#ff764114] w-10 h-10 !text-primary flex items-center justify-center text-xl" onClick={e => edit(itm.id)}>
                                    <FiEdit3 />
                                </a>
                            </Tooltip>
                            : <></>} */}
                        {isAllow(`delete${shared.check}`) ? <Tooltip placement="top" title="Delete"> <span className='border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-9 h-9 text-neutral-800 flex items-center justify-center text-md ' onClick={() => deleteItem(itm.id)}>
                            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>
                        </span> </Tooltip> : <></>}
                    </div>
                </>
            }
        }] : []),
    ]




    return (
        <Layout>
            <div className="flex flex-wrap justify-between items-center gap-y-4">
                <div>
                    <h3 className="text-2xl font-semibold text-[#111827]"> {shared.title}s {total ? `(${total})` : ''}</h3>
                    <p class="text-sm font-normal text-[#75757A]">Here you can see all about your {shared.title}s</p>
                </div>

                <a id='downloadFile'></a>

                <div className="flex">


                    {/* <button className="!px-2.5 text-[#3C3E49] text-sm font-normal py-2.5 flex items-center justify-center gap-2 bg-[#fff] rounded-lg shadow-btn hover:bg-[#F3F2F5] border border-[#D0D5DD] transition-all focus:ring-2 ring-[#F1F2F3] disabled:bg-[#F3F2F5] disabled:cursor-not-allowed mr-3" onClick={() => exportfun()}>
                        <PiFileCsv className="text-typo text-xl" />  Export CSV
                    </button> */}

                    {isAllow(`add${shared.check}`) ?
                        <button className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2" onClick={handleAddMember}>
                            +   Add {shared.title}
                        </button>
                        : <></>}
                </div>


            </div>



            <div className='shadow-box w-full bg-white rounded-lg mt-6 '>


                {/* search */}
                <form className="flex items-center max-w-sm p-6 pb-0" onSubmit={e => {
                        e.preventDefault()
                        filter()
                    }}>
                        <label for="simple-search" className="sr-only">Search</label>
                        <div className="relative w-full">
                            {/* <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5v10M3 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0V6a3 3 0 0 0-3-3H9m1.5-2-2 2 2 2"/>
                                </svg>
                            </div> */}
                            <input type="text" id="simple-search"
                                value={filters.search}
                                onChange={e => {
                                    setFilter({ ...filters, search: e.target.value })
                                }}
                                className="bg-gray-50 pr-10 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-orange-500 focus:border-orange-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-orange-500 dark:focus:border-orange-500" placeholder="Search" required 
                            
                                />
                                {filters?.search && (
                        <i
                          className="fa fa-times absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm"
                          aria-hidden="true"
                          onClick={(e) => clear()}
                        ></i>
                      )}
                        </div>
                        <button type="submit" class="p-2.5 ms-2 text-sm font-medium text-white bg-blue-700 rounded-lg border border-orange-500  focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                            <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg>
                            <span class="sr-only">Search</span>
                        </button>
                    </form>
                {/*  */}
                <div className='flex p-4 justify-end'>
                    <div className="flex gap-2">
                        {/* <SelectDropdown
                            id="statusDropdown"
                            displayValue="name"
                            placeholder='All Status'
                            intialValue={filters.status}
                            result={e => { changestatus(e.value) }}
                            options={statusModel.list}
                        /> */}
                        {filters.status ? <>
                            <button
                                className="bg-primary leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg"
                                onClick={() => clear()}>
                                Reset
                            </button>
                        </> : <></>}


                    </div>
                </div>



                {!loaging ? <>
                    <Table
                        className='mb-3'
                        data={data}
                        columns={columns}
                        page={filters.page}
                        count={filters.count}
                        total={total}
                        nodata="No members yet"
                        result={(e) => {
                            if (e.event == 'page') pageChange(e.value)
                            if (e.event == 'sort') sorting(e.value)
                            if(e.event == 'count') count(e.value)
                        }}
                    />

                </> : <>
                
                </>}

                {
                    loaging ? <div className="text-center py-4">
                        <img src="/assets/img/loader.gif" className="pageLoader" />
                    </div> : <></>
                }

            </div>

            {invitations.length > 0 && (
                <div className='shadow-box w-full bg-white rounded-lg mt-6'>
                    <div className="p-6 pb-3 flex justify-between items-center">
                        <div>
                            <h4 className="text-lg font-semibold text-[#111827]">Pending Invitations ({invitations.length})</h4>
                            <p className="text-sm font-normal text-[#75757A]">Invitations that have not been accepted yet</p>
                        </div>
                        {invitations.some(inv => inv.status === 'failed' || inv.status === 'expired' || (inv.expiresAt && new Date(inv.expiresAt) < new Date())) && (
                            <button
                                className="bg-primary leading-10 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2"
                                onClick={() => resendAllInvitations()}
                            >
                                Resend All
                            </button>
                        )}
                    </div>
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3">Email</th>
                                    <th className="px-6 py-3">Name</th>
                                    <th className="px-6 py-3">Status</th>
                                    <th className="px-6 py-3">Invited</th>
                                    <th className="px-6 py-3">Expires</th>
                                    <th className="px-6 py-3">Revoke Invitation</th>
                                    <th className="px-6 py-3">Delete Item</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...invitations].sort((a, b) => {
                                    const nameA = (a.firstName || (a.fullName || '').split(' ')[0] || a.email || '').toLowerCase();
                                    const nameB = (b.firstName || (b.fullName || '').split(' ')[0] || b.email || '').toLowerCase();
                                    return nameA.localeCompare(nameB);
                                }).map((inv) => {
                                    const isFailed = inv.status === 'failed';
                                    const isExpired = isFailed || inv.status === 'expired' || (inv.expiresAt && new Date(inv.expiresAt) < new Date());
                                    return (
                                        <tr key={inv._id} className="bg-white border-b">
                                            <td className="px-6 py-4">{inv.email}</td>
                                            <td className="px-6 py-4 capitalize">{inv.fullName || `${inv.firstName || ''} ${inv.lastName || ''}`.trim() || '-'}</td>
                                            <td className="px-6 py-4">
                                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                                    isExpired
                                                        ? 'bg-red-100 text-red-800'
                                                        : 'bg-yellow-100 text-yellow-800'
                                                }`}>
                                                    {isFailed ? 'Failed to Send' : isExpired ? 'Expired' : 'Pending'}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4">{inv.createdAt ? new Date(inv.createdAt).toLocaleDateString() : '-'}</td>
                                            <td className="px-6 py-4">{inv.expiresAt ? new Date(inv.expiresAt).toLocaleDateString() : '-'}</td>
                                            <td className="px-6 py-4">
                                                {isExpired ? (
                                                    <Tooltip placement="top" title="Resend Invitation">
                                                        <span
                                                            className='border cursor-pointer !border-[#3085d6] hover:opacity-70 rounded-md bg-[#3085d614] w-9 h-9 text-blue-600 flex items-center justify-center text-md'
                                                            onClick={() => resendInvitation(inv._id)}
                                                        >
                                                            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/><path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/></svg>
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip placement="top" title="Revoke Invitation">
                                                        <span
                                                            className='border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-9 h-9 text-neutral-800 flex items-center justify-center text-md'
                                                            onClick={() => revokeInvitation(inv._id)}
                                                        >
                                                            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg>
                                                        </span>
                                                    </Tooltip>
                                                )}
                                            </td>
                                            <td className="px-6 py-4">
                                                <Tooltip placement="top" title="Delete Item">
                                                    <span
                                                        className='border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-9 h-9 text-neutral-800 flex items-center justify-center text-md'
                                                        onClick={() => deleteInvitation(inv._id)}
                                                    >
                                                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>
                                                    </span>
                                                </Tooltip>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </Layout >
    );
};

export default Html;
